import { dataHooks } from '@wix/data-hooks'

export const wixMobileWelcomeDataHooks = dataHooks<{
  skip: {}
  stepProgressBar: {}
  title: {}
  description: {}
  option: { key: string; isChecked: boolean }
  optionFormField: { key: string }
  next: { isDisabled: boolean }
  disclaimer: {}
  successMessage: {}
}>('wix-mobile-welcome')
